import type { SendEmailDTO, SendEmailOptions } from '../types';

/**
 * Sends email (e.g. documentation) via the provided transport and endpoint.
 *
 * @param dto - Primitive payload (to, subject, body, attachments, etc.)
 * @param options - transport and endpoint (provided by the calling module)
 * @returns Response from transport.post
 */
export async function sendEmail(
    dto: SendEmailDTO,
    options: SendEmailOptions
): Promise<{ data?: unknown }> {
    const { transport, endpoint, config } = options;
    return transport.post(endpoint, dto, config);
}
